import { ConversationResolutionStatus, User } from 'lib-shared-types-api';

import {
  ConversationMessageDeliveryEventComputed,
  ConversationSummaryInfo,
} from './_temporary';

import { ConversationFormEmailUser } from './email';
import type { ConversationsChannels } from './global';
import type { Tag } from './tag';

export type Conversation = {
  message_delivery_status: Record<
    string,
    ConversationMessageDeliveryEventComputed
  > | null;
  assignment?: Assignment | null;
  assignments?: Array<Assignment> | null;
  async_integrations?: Array<any>;
  attributes?: Record<string, string>;
  authors?: {
    [key: string]: User;
  } | null;
  closed_at?: string | null;
  closed_by?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  direction?: ConversationDirection | null;
  queued_at: string | null;
  events?: Array<any> | null;
  id?: number | null;
  initial_channel?: ConversationsChannels | null;
  inboundmessagecount?: number;
  live_assesment?: {
    is_end_user_connected: boolean;
    timestamp: string;
  } | null;
  is_closed: boolean;
  is_abandoned: boolean | null;
  last_seen?: any;
  org_id?: string | null;
  outboundmessagecount?: number;
  queue?: { id: string; name: string; is_restricted: boolean } | null;
  queue_at?: string | null;
  ratings?: Array<Rating>;
  requested_by?: string | null;
  tags?: Array<Tag>;
  last_message_created_at: string | null;
  pending_expiration_at?: string | null;
  pending_at?: string | null;
  pending_by?: string | null;
  status: ConversationStatus | null;
  is_callback_consumed: boolean;
  numeric_id?: number;
  linked_to?: any;
  linked_at?: string | null;
  link_type?: string | null;
  summary?: ConversationSummaryInfo;
  resolution?: ConversationResolutionStatus | null;
};

export type Rating = {
  id: string;
  type: string;
  score: number;
  message?: string | null;
  created_at?: string | null;
};

export type Assignment = {
  assigned_at?: string | null;
  unassigned_at?: string | null;
  agent_id?: string | null;
  agent?: User | null;
};

export type ConversationAttributes = {
  subject: string | null;
};

export type ConversationStatus =
  | 'open'
  | 'closed'
  | 'pending'
  | 'awaitingpending';

export type ConversationDirection = 'outbound' | 'inbound' | 'internal';

export type ConversationInfoType = {
  status?: ConversationStatus | null;
  direction?: ConversationDirection | null;
  id?: string | number | null;
  numeric_id?: number;
  created_at?: string | null;
  closed_at?: string | null;
  pending_expiration_at?: string | null;
  initial_channel?: ConversationsChannels | null;
  queue?: {
    id: string;
    name: string;
  } | null;
};

export interface ConversationSummaryLabel {
  title?: string;
  agent?: string;
  channel?: string;
  queue?: string;
  requester?: string;
}

interface ConversationStatusAttributes {
  prettyName: string;
  color: string;
}

export const conversationStatusAttributes: ReadonlyMap<
  ConversationStatus,
  ConversationStatusAttributes
> = new Map([
  ['open', { prettyName: 'Open', color: 'var(--dixa-color-green-500)' }],
  ['closed', { prettyName: 'Closed', color: 'var(--dixa-color-neutral-500)' }],
  ['pending', { prettyName: 'Follow up', color: 'var(--dixa-color-blue-500)' }],
  [
    'awaitingpending',
    { prettyName: 'Follow up', color: 'var(--dixa-color-blue-500)' },
  ],
]);

export type ConversationFormEmailValues = {
  fromEmail?: string | null;
  to?: ConversationFormEmailUser[] | null;
  cc?: ConversationFormEmailUser[] | null;
  bcc?: ConversationFormEmailUser[] | null;
};

export type ConversationFormValues = ConversationFormEmailValues & {
  attachments?: File[];
};
